import { render } from "./AddSupportAgentDialog.vue?vue&type=template&id=c5295422"
import script from "./AddSupportAgentDialog.vue?vue&type=script&lang=js"
export * from "./AddSupportAgentDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__